import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import { SelectField } from "@roc/ui";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(4),
  },
  dropdownWrapper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-start",
  },
  dropdown: {
    width: "60%",
    "& .MuiInputBase-root": {
      height: 42,
      fontSize: 14,
    },
  },
  customReasonBox: {
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "center",
    minWidth: "100%"
  },
  textArea: {
    width: "100%",
    fontSize: 14,
  },
}));

type UnsubscribeModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
};

const unsubscribeReasons = [
  "They yelled at me",
  "They aren't a fit",
  "Bad contact info",
  "Other",
];

const UnsubscribeModal: React.FC<UnsubscribeModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const classes = useStyles();
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    if (!selectedReason) {
      setError("Please select a reason");
      return;
    }
    if (selectedReason === "Other" && !customReason.trim()) {
      setError("Please provide a reason under 'Other'");
      return;
    }
    const finalReason =
      selectedReason === "Other" ? customReason.trim() : selectedReason;
    onConfirm(finalReason);
    handleClose();
  };

  const handleClose = () => {
    setSelectedReason("");
    setCustomReason("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Unsubscribe Prospect</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <SelectField
          variant={"outlined"}
          testId="unsubscribe-reason-select"
          value={selectedReason}
          onChange={(value) => {
            setSelectedReason(value);
            setError("");
          }}
          options={unsubscribeReasons.map((r) => ({ label: r, value: r }))}
          placeholder="Select a reason"
          fullWidth={false}
          style={{ width: '60%', minWidth: 320, maxHeight: 50 }}
          error={!!error && !selectedReason}
          errorText={error && !selectedReason ? error : undefined}
        />
        {selectedReason === "Other" && (
          <Box className={classes.customReasonBox}>
            <TextField
              multiline
              rows={3}
              variant="outlined"
              placeholder="Enter custom reason..."
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              className={classes.textArea}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="outlined">
          CANCEL
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          CONFIRM
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsubscribeModal;
